import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { NavigationExtras, Router } from '@angular/router';

import { KeyValuePair } from '../models';
import { InlineAlert } from '@app/shared/models';
import { TranslateService } from '@ngx-translate/core';
import { InlineAlertTypes } from '@app/shared/types/inline-alert-types';
import { DateTypes, RequestStatus, RelativeTime } from '@app/shared/types';
import * as momentJalaali from 'moment-jalaali';
import * as  _moment from 'moment-timezone';
import { TcCurrencyPipe } from '@app/shared/pipes';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Moment } from 'moment';
import { Observable } from 'rxjs';
import { AlertNewSnakbarService } from './alert-new-snakbar.service';
import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';

const moment = _moment;

@Injectable({
    providedIn: 'root'
})

export class UtilsService {

    constructor(
        private router: Router,
        private currencyPipe: CurrencyPipe,
        private datePipe: DatePipe,
        private translateService: TranslateService,
        private alertNewSnakbarService: AlertNewSnakbarService
    ) {
    }

    manageShowMore(showCount: number, allCount: number): boolean {
        if (allCount > showCount) {
            return true;
        } else {
            return false;
        }
    }

    handleResponse(response: any): any {
        return response && response['data'] || {};
    }

    handleNewResponse(response: any): any {
        const res = response['data'] ? response['data'] : JSON.parse(response)['data'];
        return res;
    }

    generateHttpParamForNewTablePaging(pageNumber: number, pageSize: number, filters: KeyValuePair[], sortOrder?: any): HttpParams {
        let params = new HttpParams()
            .set('Paging.Index', pageNumber.toString())
            .set('Paging.Size', pageSize.toString());

        filters.forEach(item => {
            params = params.append(item.key, item.value);
        });

        return params;
    }

    generateHttpParamForTablePaging(pageNumber: number, pageSize: number, filters: KeyValuePair[], sortOrder): HttpParams {
        let params = new HttpParams()
            .set('sortOrder', sortOrder)
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString());

        filters.forEach(item => {
            params = params.append(item.key, item.value);
        });

        return params;
    }

    generateHttpParamForTablePagingNew(pageNumber: number, pageSize: number, filters: KeyValuePair[], sortOrder): HttpParams {
        let params = new HttpParams()
            .set('sortOrder', sortOrder)
            .set('Paging.Index', pageNumber.toString())
            .set('Paging.Size', pageSize.toString());

        filters.forEach(item => {
            params = params.append(`Filter.${item.key}`, item.value);
        });

        return params;
    }

    generateHttpParamForTablePagingNewWithoutSort(pageNumber: number, pageSize: number, filters: KeyValuePair[]): HttpParams {
        let params = new HttpParams()
            .set('Paging.Index', pageNumber.toString())
            .set('Paging.Size', pageSize.toString());

        filters.forEach(item => {
            params = params.append(`Filter.${item.key}`, item.value);
        });

        return params;
    }

    generateHttpParamForTablePagingWithoutSort(pageNumber: number, pageSize: number, filters: KeyValuePair[], sortOrder): HttpParams {
        let params = new HttpParams()
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString());

        filters.forEach(item => {
            params = params.append(item.key, item.value);
        });

        return params;
    }

    generateHttpParamForCardPaging(pageNumber: number, pageSize: number, filters: KeyValuePair[], sortOrder): HttpParams {
        let params = new HttpParams()
            .set('sortOrder', sortOrder)
            .set('pageSize', pageSize.toString())
            .set('pageNumber', pageNumber.toString());

        filters.forEach(item => {
            params = params.append(item.key, item.value);
        });

        return params;
    }

    handleRouterNavigation(route: string, navigationExtras: NavigationExtras = null): void {

        setTimeout(() => {
            this.router.navigate([route], navigationExtras);
        }, 1);
    }

    upperCaseFirstLetter(data: string): string {
        return data.charAt(0).toUpperCase() + data.slice(1);
    }

    // file
    getAllowExtentions(allowedExt: string[]): string {
        return allowedExt.join(', ').toUpperCase();
    }

    isFileValid(file: File, allowedExt: string, maxSize: number): boolean {

        // check file extension
        if (
            !allowedExt.toUpperCase()
                .includes(
                    file.name.toUpperCase().split('.').pop())
        ) {
            return false;
        }

        // check file size
        if (file.size > maxSize) {
            return false;
        }

        return true;
    }

    makeInlineAlertForFileValidation(file: File, allowedExt: string, maxSize: number): InlineAlert[] {
        const inlineAlerts: InlineAlert[] = [];
        // check file extension
        if (
            !allowedExt.toUpperCase()
                .includes(
                    file.name.toUpperCase().split('.').pop())
        ) {
            this.translateService.get('VALIDATION.FILE_EXTENSION', { value: allowedExt }).subscribe(res => {
                inlineAlerts.push({
                    type: InlineAlertTypes.error,
                    text: res
                });
            });
        }

        // check file size
        if (file.size > maxSize) {
            let mbMaxSize = (maxSize / 1048578);
            if ((mbMaxSize % 1) != 0) {
                mbMaxSize = parseFloat(mbMaxSize.toFixed(2));
            }
            this.translateService.get('VALIDATION.FILE_MAX_SIZE', { value: mbMaxSize }).subscribe(res => {
                inlineAlerts.push({
                    type: InlineAlertTypes.error,
                    text: res
                });
            });
        }

        return inlineAlerts;
    }

    formatDateTime(date: Date, type: DateTypes, lang: string): Date {
        const value = moment.tz(date, moment.tz.guess()).format('YYYY/MM/DD hh:mm');

        let format = '';

        if (type === DateTypes.Time) {
            return momentJalaali(value).format('HH:mm');

        } else if (type === DateTypes.Date && lang === 'fa') {
            format = 'jYYYY/jMM/jDD';
            return momentJalaali(value).format(format);

        } else if (type === DateTypes.Date && lang !== 'fa') {
            format = 'YYYY/MM/DD';
            return momentJalaali(value).format(format);

        } else if (type === DateTypes.DateTime && lang === 'fa') {
            format = 'HH:mm jYYYY/jMM/jDD';
            return momentJalaali(value).format(format);

        } else {
            return momentJalaali(value).format('YYYY/MM/DD HH:mm');
        }

    }

    dateToRelativeDate(date: Date): RelativeTime {
        const msPerMinute = 60000;
        const msPerHour = 3600000;
        const msPerDay = 86400000;
        // var msPerMonth = msPerDay * 30;
        // var msPerYear = msPerDay * 365;
        const preDate = new Date(date).getTime();
        const currentDate = new Date().getTime();
        const elapsed = currentDate - preDate;
        let value;
        let text;
        if (elapsed < msPerMinute) {
            value = Math.round(elapsed / 1000);
            text = 'GENERAL.SECOND_AGO';
        } else if (elapsed < msPerHour) {
            value = Math.round(elapsed / msPerMinute);
            text = 'GENERAL.MINUTES_AGO';
        } else if (elapsed < msPerDay) {
            value = Math.round(elapsed / msPerHour);
            text = 'GENERAL.HOURS_AGO';
        } else {
            return null;
        }
        return { value, text };
        // else if (elapsed < msPerMonth) {
        //     return 'approximately ' + Math.round(elapsed / msPerDay) + ' days ago';
        // }

        // else if (elapsed < msPerYear) {
        //     return 'approximately ' + Math.round(elapsed / msPerMonth) + ' months ago';
        // }

        // else {
        //     return 'approximately ' + Math.round(elapsed / msPerYear) + ' years ago';
        // }
    }

    dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    async downloadFile(response: any, fileName: string = null): Promise<void> {
        const name = fileName
            ? fileName
            : this.getFileNameFromHttpResponse(response);

        const nameWithExt = this.ensureExtension(name, response);

        // for web
        if (!Capacitor.isNativePlatform()) {
            const link = document.createElement('a');
            link.setAttribute('type', 'hidden');
            link.download = name;
            link.href = URL.createObjectURL(response['body']);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return;
        }

        try {
            const blob = response['body'];
            const base64 = await this.blobToBase64(blob);
            const platform = Capacitor.getPlatform();

            await Filesystem.writeFile({
                path: platform === 'ios' ? nameWithExt : `Download/${nameWithExt}`,
                data: base64,
                directory: platform === 'ios'
                    ? Directory.Documents
                    : Directory.ExternalStorage,
                recursive: true,
            });

            this.alertNewSnakbarService.snackBarSuccess(
                this.getTranslation(
                    platform === 'ios'
                        ? 'APPLICATION_PWA.FILE_DOWNLOAD.SUCCESS_IOS'
                        : 'APPLICATION_PWA.FILE_DOWNLOAD.SUCCESS_ANDROID'
                )
            );
        } catch (e) {
            this.alertNewSnakbarService.snackBarError(
                this.getTranslation('APPLICATION_PWA.FILE_DOWNLOAD.ERROR')
            );
        }
    }

    private blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = (reader.result as string).split(',')[1];
                resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    private ensureExtension(name: string, response: any): string {
        // اگر پسوند دارد همان را برگردان
        if (/\.[a-zA-Z0-9]+$/.test(name)) {
            return name;
        }

        // از Content-Type پسوند بگیر
        const contentType = response['body']?.type
            || response.headers?.get('Content-Type')
            || '';

        const mimeToExt: Record<string, string> = {
            'application/pdf': '.pdf',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
            'application/vnd.ms-excel': '.xls',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'text/csv': '.csv',
            'application/zip': '.zip',
        };

        const ext = Object.entries(mimeToExt).find(([mime]) =>
            contentType.includes(mime)
        )?.[1] || '';

        return name + ext;
    }


    getFileNameFromHttpResponse(httpResponse): string {
        const contentDispositionHeader = httpResponse.headers.get('Content-Disposition');
        const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
    }

    setPrecision(value: number, precision: number): string {
        const pipe = new TcCurrencyPipe(this.currencyPipe);
        return pipe.transform(value, precision);
    }

    normalizeAmount(value: number, precision = 0, rounding = false): number {
        if (value == null || !isFinite(value)) return value as any;
        const factor = Math.pow(10, precision);

        if (!rounding) {
            // Equivalent to C#: Floor on the scaled value, with sign-aware binary compensation
            const eps = 1 / (factor * 1e6);
            const adj = value >= 0 ? eps : -eps; // ← key for negative numbers
            const scaled = (value + adj) * factor;
            const floored = Math.floor(scaled);
            return floored / factor;
        }

        // Equivalent to Round + MidpointRounding.ToEven
        const overflow = parseFloat("0." + "0".repeat(precision) + "5");
        const factorN = factor;
        let n = (value + overflow) * factorN;

        // Neutralize binary error around integers
        const eps2 = 1 / (factorN * 1e6);
        if (Math.abs(n - Math.round(n)) < eps2) n = Math.round(n);

        let r = Math.round(n);
        // If exactly at half → round to even
        const frac = n - Math.floor(n);
        if (Math.abs(frac - 0.5) < eps2 && (r % 2 !== 0)) r -= 1;

        return r / factorN;
    }

    isRequestCompleted(requestStatus: RequestStatus): boolean {
        if (
            requestStatus === RequestStatus.DONE ||
            requestStatus === RequestStatus.FAILED ||
            requestStatus === RequestStatus.REFUND ||
            requestStatus === RequestStatus.REJECTED ||
            requestStatus === RequestStatus.DELETED
        ) {
            return true;
        }
        return false;
    }

    showSideBar(): boolean {
        if (window.innerWidth > 992) {
            return true;
        }
        return false;
    }

    removeAmountSeparator(value: string): number {
        if (typeof value === 'number') return value;
        value = value.replace(/([۰-۹])/g, token => String.fromCharCode(token.charCodeAt(0) - 1728));
        return parseFloat(value.replace(/,/g, ''));
    }

    isCryptoPage(): boolean {
        return window.location.href.includes('/crypto/');
    }

    toFixedScale(num, scale: number): number {
        const converNume = parseFloat(num).toFixed((scale + 1));
        return parseFloat(converNume.substring(0, (converNume.length - 1)));
    }

    arraysEqual(a1: any, a2: any): boolean {
        return a1?.length === a2?.length && a1.every((o: any, idx: any) => this.objectsEqual(o, a2[idx]))
    };

    private objectsEqual(o1: any, o2: any): boolean {
        return typeof o1 === 'object' && Object.keys(o1)?.length > 0
            ? Object.keys(o1)?.length === Object.keys(o2)?.length
            && Object.keys(o1).every(p => this.objectsEqual(o1[p], o2[p]))
            : o1 === o2;
    }
    /*******************************************************************
     Styles
    *******************************************************************/

    manageStepperStyle(width: number, tabsCount: number): string {
        if (width < 510) {
            return 'stepper-xs';
        }

        if (width < 728) {
            return 'stepper-sm';
        }

        if (width < 1026) {
            return ('stepper-md stepper-md-' + tabsCount);
        }

        if (width < 1500) {
            return 'stepper-lg-' + tabsCount;
        }

        if (width > 1499) {
            return 'stepper-xl-' + tabsCount;
        }
    }

    formTofilterKeyValue(form: FormGroup): KeyValuePair[] {
        const filters: KeyValuePair[] = [];
        const rawValue = form.getRawValue();

        Object.keys(rawValue).forEach(key => {
            let value: any = rawValue[key];

            if (Array.isArray(value)) {
                if (value.length > 0) {
                    value.forEach(item => {
                        if (item !== null && item !== undefined) {
                            filters.push({ key, value: item });
                        }
                    });
                }
                return;
            }

            if (value || value === false || value === 0) {

                if (moment.isMoment(value)) {
                    const m = value as Moment;
                    const iso = m.toDate().toISOString();

                    value = this.datePipe.transform(iso, 'yyyy-MM-dd') ?? iso;
                }

                else if (value instanceof Date) {
                    const d = value as Date;
                    const iso = d.toISOString();
                    value = this.datePipe.transform(iso, 'yyyy-MM-dd') ?? iso;
                }

                const keyValue: KeyValuePair = { key, value };
                filters.push(keyValue);
            }
        });

        return filters;
    }


    formTofilterKeyValueWithDateTime(form: FormGroup, isDateTime: boolean = false): KeyValuePair[] {
        const filters: KeyValuePair[] = [];
        Object.keys(form.controls).forEach((key) => {
            let value = form.get(key)?.value;
            if (value && Array.isArray(value)) {
                if (value.length > 0) {
                    value.forEach((item) => {
                        if (item !== null) {
                            const keyValue: KeyValuePair = {
                                key,
                                value: item,
                            };
                            filters.push(keyValue);
                        }
                    });
                }
            } else {
                if (value || value === false || value === 0) {
                    // if (key === 'fromDate' || key === 'toDate') {
                    if (value instanceof Date) {
                        if (isDateTime) {
                            const offset = -value.getTimezoneOffset();
                            const sign = offset >= 0 ? '+' : '-';
                            const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
                            const minutes = String(Math.abs(offset) % 60).padStart(2, '0');

                            value =
                                value.getFullYear() +
                                '-' +
                                String(value.getMonth() + 1).padStart(2, '0') +
                                '-' +
                                String(value.getDate()).padStart(2, '0') +
                                'T' +
                                String(value.getHours()).padStart(2, '0') +
                                ':' +
                                String(value.getMinutes()).padStart(2, '0') +
                                ':' +
                                String(value.getSeconds()).padStart(2, '0') +
                                '.' +
                                String(value.getMilliseconds()).padStart(3, '0') +
                                sign + hours + ':' + minutes;
                        } else {
                            const date = new Date(value);
                            value = this.datePipe.transform(date, 'MM/dd/yyyy') || '';
                        }
                    }
                    const keyValue: KeyValuePair = {
                        key,
                        value,
                    };

                    filters.push(keyValue);
                }
            }
        });
        return filters;
    }


    convertToEnglishNumeral(persianNumeral: string): string {
        const persianToEnglishMap: { [key: string]: string } = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        let englishNumeral = '';
        for (let i = 0; i < persianNumeral.length; i++) {
            const persianCharacter = persianNumeral[i];
            const englishCharacter = persianToEnglishMap[persianCharacter];
            englishNumeral += (englishCharacter !== undefined ? englishCharacter : persianCharacter);
        }

        if (!englishNumeral) {
            englishNumeral = persianNumeral
        }
        return englishNumeral;
    }


    checkInternetConnection(): Observable<boolean> {
        return new Observable((observer) => {

            window.addEventListener("load", (event) => {
                return observer.next(true);
            });

            window.addEventListener("offline", (event) => {
                this.alertNewSnakbarService.snackBarError('AUTH.CONNECTION_ERROR');
                return observer.next(false);
            });

            window.addEventListener("online", (event) => {
                return observer.next(true);
            });


        });

    }

    getTranslation(key: string, name?: string, value?: number): string {
        let text = "";
        this.translateService
            .get(key, { name, value })
            .subscribe((translatedText: string) => {
                text = translatedText;
            });
        return text;
    }

    //#region  check URL
    isExternalLink(url: string): boolean {
        try {
            const parsedUrl = new URL(url, window.location.origin);
            return parsedUrl.origin !== window.location.origin;
        } catch {
            return false;
        }
    }

    toInternalPath(url: string): string {
        const origin = window.location.origin;
        if (url.startsWith(origin)) {
            return url.replace(origin, '');
        }
        return url;
    }
    //#endregion

}